import { ActionContext, Module } from 'vuex'
import { ErrorInfo, ErrorState, RootState } from '@/store/types'
import { MutationTypes } from '@/store/mutation-types'

export const getters = {
  get: (state: ErrorState) => state.errors,
  hasError: (state: ErrorState) => {
    return state.errors !== undefined && state.errors.length > 0
  },
}

export const mutations = {
  [MutationTypes.POST_ERROR](state: ErrorState, payload: Array<ErrorInfo>) {
    state.errors = payload
  },
  [MutationTypes.CLEAR_ERROR](state: ErrorState) {
    state.errors = []
  },
}

export const actions = {
  set: (
    { commit }: Pick<ActionContext<ErrorState, RootState>, 'commit'>,
    errors: Array<ErrorInfo>
  ) => {
    commit(MutationTypes.POST_ERROR, errors)
  },
  clear({ commit }: Pick<ActionContext<ErrorState, RootState>, 'commit'>) {
    commit(MutationTypes.CLEAR_ERROR)
  },
}

export const errors: Module<ErrorState, RootState> = {
  namespaced: true,
  state: () => ({
    errors: undefined,
  }),
  getters,
  mutations,
  actions,
}
